import React from "react";
import { useTranslation } from "react-i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import { Input } from "antd";
import classnames from "classnames";

import HidePasswordSvgIcon from "@components/Common/SvgIcons/HidePasswordSvgIcon";
import ShowPasswordSvgIcon from "@components/Common/SvgIcons/ShowPasswordSvgIcon";

import "./index.css";

const ERROR_TEXT_STYLE: React.CSSProperties = {
    width: "100%",
    marginTop: "0.25rem",
    fontSize: "80%",
    color: "#f46a6a",
};

const PASSWORD_INPUT_STYLE: React.CSSProperties = {
    height: "38px",
    borderRadius: "6px",
    color: "#2b2828",
    fontSize: "16px",
    fontFamily: "Segoe UI",
};

type FidelitySynapsyType = {
    password: string;
    setPassword: (v: string) => void;
    login: string;
    setLogin: (v: string) => void;
    inputLogin: boolean;
    setInputLogin: (v: boolean) => void;
    inputPassword: boolean;
    setInputPassword: (v: boolean) => void;
    setIsEdited: (v: boolean) => void;
    isConsult?: boolean;
};
export default function FidelitySynapsy({
    password,
    setPassword,
    login,
    setLogin,
    inputLogin,
    setInputLogin,
    inputPassword,
    setInputPassword,
    setIsEdited,
    isConsult,
}: FidelitySynapsyType) {
    const { t } = useTranslation();

    const handleLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLogin(e.target.value.trimStart());
        setInputLogin(false);
        setIsEdited(true);
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value.trimStart());
        setInputPassword(false);
        setIsEdited(true);
    };

    return (
        <React.Fragment>
            <AvGroup className={` ${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Login")}
                </StyledLabel>
                <StyledTextInput
                    data-testid="fidelity-franchise-synapsy-login-input"
                    autocomplete="off"
                    id="login"
                    name="login"
                    placeholder={t("Write")}
                    type="text"
                    onChange={handleLoginChange}
                    className={classnames("fed_inp_FRlogin", {
                        input__clz: inputLogin,
                    })}
                    value={login}
                />
                {inputLogin ? (
                    <div style={ERROR_TEXT_STYLE}>
                        {t("Please enter a login")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={` ${isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Password")}
                </StyledLabel>
                <Input.Password
                    data-testid="fidelity-franchise-synapsy-password-input"
                    placeholder={t("Write")}
                    iconRender={(visible) =>
                        visible ? (
                            <ShowPasswordSvgIcon />
                        ) : (
                            <HidePasswordSvgIcon />
                        )
                    }
                    onChange={handlePasswordChange}
                    value={password}
                    className={classnames("fed_inp_FRpassword", {
                        input__clz: inputPassword,
                    })}
                    style={PASSWORD_INPUT_STYLE}
                />
                {inputPassword ? (
                    <div style={ERROR_TEXT_STYLE}>
                        {t("Please enter a password")}
                    </div>
                ) : null}
            </AvGroup>
        </React.Fragment>
    );
}
